'use strict'
import React from 'react'
import { withTranslation as translate } from 'react-i18next'

class StoriesGrid extends React.PureComponent {
  render() {
    const _t = this.props.t
    return (
      <div className="stories-section-content-wrapper clearfix">
        <a
          href={`/content/tips-articles/podcast-the-wheelchair-tourist/`}
          className="stories-item item-big rome"
        >
          <img
            className="bg"
            src={require('../../images/home-page/wheelchairtourist.png')}
            alt="Wheelchair Tourist"
            title={_t('homepage_community_stories_travel_to_rome')}
          />
          <div className="stories-item-content">
            <div className="avatar-and-link-holder">
              {/* <img
                className="stories-item-content-avatar"
                src={require('../../images/home-page/avatar-cory.jpg')}
                alt="Cory Lee"
                title="Cory Lee"
              /> */}
              <div className="stories-item-content-link">
              Podcast: <br />The Wheelchair Tourist
              </div>
            </div>
          </div>
        </a>
        <a
          href={`/content/tips-articles/enjoying-accessible-london-autumn/`}
          className="stories-item irina"
        >
          <img
            className="bg"
            src={require('../../images/home-page/londonlondon.jpg')}
            alt="London"
            title={_t('homepage_community_stories_meet_irina')}
          />
          <div className="stories-item-content">
            <div className="avatar-and-link-holder">
              <div className="stories-item-content-link">
              Enjoy Accessible London In Autumn
              </div>
            </div>
            <button className="stories-item-content-btn">
              {_t('homepage_community_stories_get_inspired')}
            </button>
          </div>
        </a>
        <a
          href="/content/tips-articles/wheelchair-accessible-amsterdam/"
          className="stories-item aron"
        >
          <img
            className="bg"
            src={require('../../images/home-page/amsterdam.jpg')}
            alt="Aron Andersson on desert road"
            title={_t('homepage_community_stories_meet_aron')}
          />
          <div className="stories-item-content">
            <div className="avatar-and-link-holder">

              <div className="stories-item-content-link">
              An Accessible Guide to Amsterdam:<br/> What to See and How to Get Around
              </div>
            </div>
            <button className="stories-item-content-btn">
              {_t('homepage_community_stories_empower')}
            </button>
          </div>
        </a>
      </div>
    )
  }
}

export default translate()(StoriesGrid)
